module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBbaIe17AAAARElEQVQ4y2P4jwQ+MAww7wADDNgPAh4z2FGDg8cAERoMPP7//xkYQMRg4P1hQAqlgeVBE85g4QGTz5/BwhsseXrwlHUAuNSzh26FUs8AAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDgtMTNUMTU6Mjc6MDgrMDk6MDAQgurLAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDEzLTEwLTA4VDA2OjA4OjIyKzA5OjAwP6gozQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h10/tag36_10_01347_100x100.png
// module id = oGzT
// module chunks = 0